import * as React from "react";

import { cn } from "@/shared/lib/utils";

export interface InputProps extends React.ComponentProps<"input"> {
  allowAutoComplete?: boolean;
}

function Input({ className, type, allowAutoComplete = false, ...props }: InputProps) {
  const autoCompleteAttributes = allowAutoComplete
    ? {}
    : {
        "data-lpignore": "true",
        "data-1p-ignore": "true",
        "data-bwignore": "true",
        "data-chrome-autocomplete": "off",
        "data-google-autocomplete": "off",
      };

  const autoCompleteValue = allowAutoComplete ? props.autoComplete : "off";

  return (
    <input
      type={type}
      data-slot="input"
      autoComplete={autoCompleteValue}
      autoCorrect="off"
      data-form-type="other"
      {...autoCompleteAttributes}
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground border-input flex h-9 w-full min-w-0 rounded-md border bg-white px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 aria-invalid:border-destructive",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
